export default {
  removeModal ({ commit }, id) {
    commit('removeModalById', id)
  }
}
